module.exports = __webpack_public_path__ + "static/img/林内鲸吨吨虎鲸.e7ef8aed.png";